module.exports = __webpack_public_path__ + "img/3.8fc84947.jpeg";